import { Component, OnInit, Input, IterableDiffer, IterableChanges, IterableDiffers, Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CcLoginComponent , PasswordRecoverComponent , CcRegisterComponent} from 'cc-components-lib';
import { UserInformation } from '../../../models/userInformation.model';
import { Plan } from '../../../models/plan.model';
import { DetailModal } from '../../../models/detailModal.model';
import { DataLayerService } from '../../../services/dataLayer/data-layer.service';
import { ProductsService } from '../../../services/products/products.service';
import { CookieCiencuadras } from '../../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { Encrypt } from '../../../utils/encrypt/encrypt';
import { AppState } from '../../../app.reducer';
import { addToCarPlan, removePlanFromCar } from '../../../redux/actions/carPlanCheckout.actions';
import { DetailModalComponent } from '../detail-modal/detail-modal.component';
import { LoginComponent } from '../../../commons/login-component/login-component.component';

@Component({
  selector: 'app-carousel-card',
  templateUrl: './carousel-card.component.html',
  styleUrls: ['./carousel-card.component.scss']
})

export class CarouselCardComponent implements OnInit {
  // private _items = new BehaviorSubject<Plan[]>([]);
  public OwlOptions: any;
  public OwlOptionsSecondary: any;
  public value = 1;
  @Input()
  dataPlan: Plan[] = [];
  @Input()
  Parents: any;
  private _diff!: IterableDiffer<Plan>;
  userInformation: UserInformation;
  public planSelected!: Plan;
  public clientType!: string;
  public dataPlanConstructionCompany: Plan[] = [];
  image_url: string = './assets/images/products/';
  childrenPlan: Plan[] = [];
  MesesPlanArray: any = [];
  idPlan: number = 0;
  user_id: string = '';

  constructor(
    private cookieCiencuadras: CookieCiencuadras,
    private router: Router,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private dialog2: MatDialog,
    @Optional() public dialogRef: MatDialogRef<LoginComponent>,
    private _iterableDiffers: IterableDiffers,
    private dataLayerService: DataLayerService,
    private productsService: ProductsService
  ) {
    this.OwlOptions = {
      autoplay: true,
      autoplayTimeout: 50000,
      //autoplayHoverPause: true,
      // mouseDrag: true,
      touchDrag: false,
      pullDrag: false,
      dots: false,
      navText: ['<span class="icon-arrow-left"></span>',
        '<span class="icon-arrow-right"></span>'],
      nav: true,
      loop: true,
      responsive: {
        0: {
          items: 1,
          margin: 15,
          stagePadding: 50,
          startPosition: 1,
          touchDrag: false,
          pullDrag: false,
        },
        600: {
          items: 2,
          margin: 15,
          stagePadding: 50,
          startPosition: 1,
          loop: true,
          touchDrag: false,
          pullDrag: false,
        },
        960: {
          items: 3,
          margin: 30,
          stagePadding: 0,
          startPosition: 0,
          loop: true,
        }
      },
    };
    this.OwlOptionsSecondary = {
      autoplay: false,
      autoplayTimeout: 50000,
      autoplayHoverPause: false,
      // mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      dots: false,
      navText: ['<span class="icon-arrow-left"></span>',
        '<span class="icon-arrow-right"></span>'],
      nav: true,
      loop: false,
      responsive: {
        0: {
          items: 1,
          margin: 15,
          stagePadding: 50,
          startPosition: 1,
        },
        600: {
          items: 2,
          margin: 24,
          stagePadding: 50,
          startPosition: 1,
        }
      },
    };
  }

  ngOnInit(): void {
    let cripto = new Encrypt();
    this.user_id = this.cookieCiencuadras.getCookie('user_id') ? this.cookieCiencuadras.getCookie('user_id') : localStorage.getItem('currentUser');
    this.clientType = this.cookieCiencuadras.getCookie('clientType');
    this._diff = this._iterableDiffers.find(this.dataPlan).create();
    let dataUser = this.cookieCiencuadras.getCookie('userInfo');
    this.userInformation = cripto.decryptData(dataUser);
  }

  async verifySessioUser(){
    const customEvent = new CustomEvent('eventFromMfe', {detail: {modal: 1 , typeUser: 'user'}});
    window.dispatchEvent(customEvent);
    this.cookieCiencuadras.setCookie('clientType', this.clientType);
  }

  async getUserInformation(id: string): Promise<boolean> {

    return new Promise((resolve) => {
      this.productsService.getUserInformation(
        id
      ).pipe().subscribe(res => {
        console.log('------------------', res);
        if (res.status) {
          let cripto = new Encrypt();
          this.userInformation = res.data;
          this.cookieCiencuadras.setCookie('userInfo', cripto.encryptData(this.userInformation));
          resolve(true);
        }
        resolve(false);
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
        resolve(false);
      });
    });
  }

  public ngDoCheck(): void {
    const changes: IterableChanges<Plan> | null = this._diff.diff(this.dataPlan);
    if (changes) {
      this.loadPlansConstructor();
      sessionStorage.setItem("dataPlan", JSON.stringify(this.dataPlan));
    }
  }

  loadPlansConstructor() {
    this.dataPlanConstructionCompany = [];
    if (this.clientType === '3') {
      for (let i = 0; i < this.dataPlan.length; i++) {
        if (this.dataPlan[i].validity === 1 && this.value === 1) {
          this.dataPlanConstructionCompany.push(this.dataPlan[i]);
        }
        if (this.dataPlan[i].validity === 3 && this.value === 2) {
          this.dataPlanConstructionCompany.push(this.dataPlan[i]);
        }
      }
    }
  }

  onClickSelectPlan(plan: Plan) {
    if(!this.user_id){
      this.verifySessioUser();
      return;
    }
    this.convertParentDataPlan(plan, this.Parents)
    sessionStorage.setItem("idPlanSelect", this.idPlan.toString());
    let parent = JSON.parse(sessionStorage.getItem("dataPlan"));
    if (parent != null) {
      let newplan = parent.find(x => x.id == plan.id);
      sessionStorage.setItem("parent", JSON.stringify(newplan));
    }
    if (this.idPlan != 0) {
      let planParent = this.childrenPlan.find(x => x.id == this.idPlan);
      if (planParent != undefined) {
        plan = planParent;
      }
      sessionStorage.setItem("nowPlan", JSON.stringify(plan));
      this.verifyPlanLocalStorage(plan);
    } else {
      sessionStorage.setItem("idPlanSelect", plan.id.toString());
      sessionStorage.setItem("nowPlan", JSON.stringify(plan));
      this.verifyPlanLocalStorage(plan);
    }
    this.router.navigateByUrl('/arma-tu-plan');
  }

  addPlan(plan:Plan){
    this.dataLayerService.pushTagByEventCar(plan, 'addToCart', 'add', 1);
    this.store.dispatch(addToCarPlan({ plan }));
  }

  verifyPlanLocalStorage(plan:Plan){
    if(localStorage.getItem('__app_storage__') !== null){
      const objPlans = JSON.parse(localStorage.getItem('__app_storage__')!).carPlanCheckout;
      if(objPlans[0]){
        this.store.dispatch(removePlanFromCar({ id: objPlans[0].id }));
      }
      this.addPlan(plan);
    }else{
      this.addPlan(plan);
    }
  }

  selectType(n: number, label: string = 'Planes semestrales'): void {
    this.dataLayerService.pushTagEventClick({ 'event': 'ga_event', 'category': 'productos', 'action': 'CCW - tipo plan', 'label': label })
    this.value = n;
    this.loadPlansConstructor();
  }

  openDetailDialog(namePlanSelected: string) {
    this.dataLayerService.pushTagEventClick({ 'event': 'ga_event', 'category': 'productos', 'action': 'CCW - ver plan', 'label': 'Ver más detalles' });
    for (let i = 0; i < this.dataPlan.length; i++) {
      if (this.dataPlan[i].name === namePlanSelected) {
        this.planSelected = this.dataPlan[i];
      }
    }
    let dataLayerProduct: { name: string; id: number; price: number; brand: string; category: string; list: string; position: number; }[] = [{
      name: this.planSelected.name,
      id: this.planSelected.id,
      price: this.planSelected.price,
      brand: 'ciencuadras',
      category: 'Publicacion',
      list: 'Home planes',
      position: 0
    }];
    if (this.planSelected.includedProducts.length >= 0) {
      this.planSelected.includedProducts.forEach((product, index) => {
        dataLayerProduct.push({
          name: product.nombre,
          id: product.id,
          price: product.precio,
          brand: 'ciencuadras',
          category: 'Publicacion',
          list: 'Home planes',
          position: index + 1
        })
      });
    }

    this.dataLayerService.onPushDataLayer({
      '​ecommerce': {
        'currencyCode': '​COP',
        'impressions': dataLayerProduct
      }
    });

    const detailConfig = new MatDialogConfig();
    detailConfig.panelClass = 'detail-modal';
    detailConfig.maxWidth = '100vw';
    detailConfig.data = this.planSelected;
    this.dialog.open(DetailModalComponent, detailConfig);
  }

  convertParentDataPlan(data: Plan, parents: any) {
    this.childrenPlan = [];
    sessionStorage.setItem("childrenPlan", "");
    let pos = 1;
    for (let i = 0; i < parents?.length; i++) {
      if (data.id === parents[i].id) {
        parents[i].data.forEach(item => {
          let clientType = this.cookieCiencuadras.getCookie('clientType')
          let products = item.caracteristicasPlan ? item.caracteristicasPlan.split(";") : "";
          let relevantChar: string[] = [];
          if (item.caracteristicasRelevantes !== undefined && item.caracteristicasRelevantes !== null) {
            relevantChar = item.caracteristicasRelevantes.split(";");
          }
          let colorCard = '';
          if (clientType === '2') {
            colorCard = 'bg-gradient-green-1';
          } else if (clientType === '1') {
            colorCard = 'bg-gradient-blue-3';
          }
          let detail: DetailModal = {
            name: item.nombre,
            price: item.precio,
            validity: item.mesesVigenciaNumero,
            validityLabel: item.etiquetaVigenciaServicio,
            priceLabel: item.etiquetaPrecioDetalle,
            topDescription: item.descripcionSuperiorDetalle,
            relevantCharacteristics: relevantChar,
            terms: item.terminosDetalle,
            aditionalInfoHTML: item.informacionAdicionalHtml,
            urlName: '',
            url: '',
            duration: item.tiempoDuracionNumero,
            unitTimeDuration: item.unidadTiempoNumero,
            duratrionLabel: item.descripcionDuracionProducto,
            image_url: item.imagenEstatica + '-detalle',
            discount: item.porcentajeDescuentoNumero,
            priceDiscount: item.precio,
            type: 'plan'
          }
          let plan: Plan = {
            external_product_id: Date.now().toString(),
            carritoId: item.carritoId,
            token: "",
            id: item.id,
            name: item.nombre,
            summary: products,
            price: item.precio,
            basePrice: item.precioBase,
            descriptionValuePlan: item.descripcionValorPlan,
            stock: item.stock,
            available_stock: item.disponibleStock,
            image_url: item.imagenEstatica,
            image_alt: item.altImagen,
            iva: item.iva,
            priceIva: item.ivaPrecio,
            idClientType: clientType,
            discount: item.porcentajeDescuentoNumero,
            priceDiscount: item.precio,
            validity: item.mesesVigenciaNumero,
            colorCard: colorCard,
            termsDescription: item.descripcionTerminos,
            detailModal: detail,
            includedProducts: item.productoDTOList,
            position: pos,
          };
          pos++;
          this.childrenPlan.push(plan);
        });
      }
    }
    sessionStorage.setItem("childrenPlan", JSON.stringify(this.childrenPlan));
  }

  changePlans(idplan, plan) {
    this.idPlan = idplan;
    this.convertParentDataPlan(plan, this.Parents);
    let dataplan = JSON.parse(sessionStorage.getItem("dataPlan"));
    if (dataplan != null || dataplan != undefined) {
      let newplan = dataplan.find(x => x.id == idplan) == undefined ? this.childrenPlan.find(c => c.id == idplan) : dataplan.find(x => x.id == idplan);
      plan.name = newplan.name;
      plan.price = newplan.price;
      plan.priceDiscount = newplan.priceDiscount;
      plan.descriptionValuePlan = newplan.descriptionValuePlan;
      plan.summary = newplan.summary;
    }
  }

  OpenOnboardingModal(Onboarding: any){
    this.dialog2.closeAll();
    if(Onboarding.modal == 1){
      this.OpenLoginModal(Onboarding.typeUser);
    } 
    if(Onboarding.modal == 2){
      this.OpenRecoverPwModal(Onboarding.typeUser);
    } 
    if(Onboarding.modal == 3){
      this.OpenRegisterModal(Onboarding.typeUser);
    } 
  }

  OpenLoginModal(typeUser: string){
    let DialogRefLogin = this.dialog2.open(CcLoginComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRecoverPwModal(typeUser: string){
    let DialogRefRecover = this.dialog2.open(PasswordRecoverComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal'
    });   
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });   
  }

  OpenRegisterModal(typeUser: string){
    let DialogRefRegister = this.dialog2.open(CcRegisterComponent , {
      data:  {'isModal': true , 'typeUser': typeUser},
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  async openDialog() {
    let dialogRef = this.dialog2.open(CcLoginComponent , {
      data:  {'isModal': true },
      panelClass: 'onboardingModal',
      autoFocus: false,
      maxHeight: '100vh'
    });
    dialogRef.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });

    return this.dialogRef?.afterClosed()
      .toPromise() // here you have a Promise instead an Observable
      .then(result => {
        console.log('login result: ', result);
        return Promise.resolve(result.detail.data.message); // will retun a Promise here
      });
  }
}